import { STORAGE_TOKEN } from '../constants';
import { createBrowserHistory } from 'history';
import React from 'react';
import { FormData } from '../@types';

import { History } from 'history';
import { refreshToken } from './refreshToken';

const isTokenExpired = (token: string): boolean => {
  try {
    const [, payload] = token.split('.');
    const decodedPayload = JSON.parse(atob(payload));
    const expirationTime = decodedPayload.exp * 1000;
    return Date.now() > expirationTime;
  } catch (error) {
    console.error('Error checking token expiration:', error);
    return true;
  }
};

export const getAuthToken = async (history?: History | string[]): Promise<string | null> => {
  try {
    const token = sessionStorage.getItem(STORAGE_TOKEN);

    if (!token) {
      history ? history.push('/auth') : null;
      return null;
    }

    if (isTokenExpired(token)) {
      await refreshToken(history);
      return sessionStorage.getItem(STORAGE_TOKEN);
    }

    return token;
  } catch (error) {
    return null;
  }
};


export const ensureAuthenticated = async (history?: History | string[]): Promise<string | null> => {
  const token = await getAuthToken();
  if (!token) {
    history ? history.push('/auth') : null;
  }
  return token
};

export const isPasswordValid = (password: string) => {
  const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
  if (!pattern.test(password)) {
    return 'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, and one number';
  }
  return '';
};

/**
 * @param {string} min Minimum number to generate
 * @param {number} max Maximum number to generate
 * @returns {string}
 */
export const generateNumber = (min = 1, max = 9000000): string => {
  min = Math.ceil(min);
  max = Math.floor(max);
  const num = Math.floor(Math.random() * (max - min + 1)) + min;
  return num.toString().padStart(12, '0');
};

export const sortData = <T extends Object>(
  data: Array<T>,
  sortColumn: keyof T,
  sortDirection: 'ASC' | 'DESC',
): Array<T> => {
  return data.sort((a, b) => {
    if (a[sortColumn] < b[sortColumn]) {
      return sortDirection === 'ASC' ? -1 : 1;
    }
    if (a[sortColumn] > b[sortColumn]) {
      return sortDirection === 'ASC' ? 1 : -1;
    }
    return 0;
  });
};

export const copyToClipboard = async (data: string) => {
  await navigator.clipboard.writeText(data);
};

export const history = createBrowserHistory();

export const shortenFileName = (file: File, length = 25) => {
  const name = file.name;
  if (name.length > length) {
    const fileType = file.type.split('/')[1];
    const fileName = name.substring(0, length - 4);

    return fileName + '...' + fileType;
  }

  return name;
};

export const ValidateFormSubmit = (
  formData: FormData,
  setValidationResults: React.Dispatch<React.SetStateAction<FormData>>,
  setError: React.Dispatch<React.SetStateAction<string>>,
) => {
  const errors = {
    firstName: '',
    lastName: '',
    phone: '', 
    email: '',
    createPassword: '',
    confirmPassword: '',
    businessName: '',
  };

  const validPassword = /^(?=.*[a-zA-Z])(?=.*[0-9])/.test(formData.createPassword);

  if (!formData.businessName) {
    errors.businessName = 'Business Name is required';
  }

  if (!formData.email) {
    errors.email = 'Email is required';
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = 'Email is invalid';
  }

  if (!formData.createPassword) {
    errors.createPassword = 'Password is required';
  }

  if (formData.createPassword !== formData.confirmPassword) {
    errors.createPassword = 'Passwords must match';
  } else if (!validPassword) {
    errors.createPassword = 'Password must be alphanumeric';
  }

  setValidationResults(errors);

  for (const key in errors) {
    if (errors.hasOwnProperty(key)) {
      if (errors[key as keyof typeof errors]) {
        setError(errors[key as keyof typeof errors]);
        return true; // errors are found
      }
    }
  }

  return false; // no errors found
};


type barChartData = {
  [key: string]: {
    expense: number;
    invoice: number;
  };
};



export function shortenText(text: string | undefined | null, maxLength: number, ellipsis: string = "..."): string {
  if (!text) {
    return ""; // Handle undefined or null input gracefully
  }

  if (text.length <= maxLength) {
    return text;
  }

  return text.substring(0, maxLength - ellipsis.length) + ellipsis;
}

